import { ValidatedSingleStringValueInputProps } from '../types';
import { useTranslation } from '../../../../hooks/useTranslation';
import { useQueryStateContext } from '../../../../contexts';
import { useVisualComponentsContext } from '../../../../contexts/visualComponents';

/**
 * For object dataTypes we show null by default.
 * However, if the feature requires showing an input (ie: Segmentation) this allows us to pass a custom version of this input
 */
export const SingleObjectInput = ({
  value,
  onChange,
  isInvalid,
  isOpenByDefault,
  hasWarning,
  dataType,
  field,
  fieldType,
  comparator,
}: ValidatedSingleStringValueInputProps) => {
  const { t } = useTranslation();
  const { isReadOnly } = useQueryStateContext();
  const { ConditionValueSingleStringInput: VisualComponent } = useVisualComponentsContext();

  const isDisabled = !!isReadOnly;
  const hasError = !!isInvalid;

  return VisualComponent ? (
    <VisualComponent
      onChange={onChange}
      value={value}
      hasError={hasError}
      hasWarning={hasWarning}
      isOpenByDefault={isOpenByDefault}
      isDisabled={isDisabled}
      dataType={dataType}
      field={field}
      fieldType={fieldType}
      comparator={comparator}
      options={[]}
      placeholder={t('v2.conditionBuilder.singleStringPlaceholder')}
    />
  ) : null;
};
